import { render, staticRenderFns } from "./peoEditer.vue?vue&type=template&id=4d37d86d&scoped=true&"
import script from "./peoEditer.vue?vue&type=script&lang=js&"
export * from "./peoEditer.vue?vue&type=script&lang=js&"
import style0 from "./peoEditer.vue?vue&type=style&index=0&id=4d37d86d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d37d86d",
  null
  
)

export default component.exports